import { Divider } from '@/components/base/divider'
import { Outlet } from 'react-router'
import {
  ArchiveBoxIcon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  CalendarIcon,
  CubeIcon,
  CurrencyPoundIcon,
  DocumentCurrencyPoundIcon,
  DocumentIcon,
  PuzzlePieceIcon,
  UserGroupIcon,
  UserIcon,
  VariableIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline'
import { SettingsSection } from './settings_section'

const sections = [
  [
    { name: 'Company details', href: '/settings/company-details', icon: BuildingStorefrontIcon },
    { name: 'Users', href: '/settings/users', icon: UserIcon },
    // { name: 'Groups', href: '/settings/groups', icon: UsersIcon },
  ],
  [
    { name: 'Integrations', href: '/settings/integrations', icon: PuzzlePieceIcon },
  ],
  [
    { name: 'Tax rates', href: '/settings/tax-rates', icon: DocumentCurrencyPoundIcon },
    { name: 'Charge multipliers', href: '/settings/charge-multipliers', icon: CurrencyPoundIcon },
  ],
  [
    { name: 'Client types', href: '/settings/client-types', icon: UserGroupIcon },
    { name: 'Categories', href: '/settings/categories', icon: CubeIcon },
    { name: 'Warehouses', href: '/settings/warehouses', icon: BuildingOfficeIcon },
    { name: 'Document types', href: '/settings/document-types', icon: DocumentIcon },
    { name: 'Maintenance types', href: '/settings/maintenance-types', icon: WrenchScrewdriverIcon },
    { name: 'Maintenance schedules', href: '/settings/maintenance-schedules', icon: CalendarIcon },
    { name: 'Custom fields', href: '/settings/custom-fields', icon: VariableIcon },
  ],
  [
    { name: 'Imports', href: '/settings/imports', icon: ArchiveBoxIcon },
  ],
]

export const Layout = () => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-12">
          <aside className="flex w-64">
            <nav className="w-full">
              <ul className="flex flex-col gap-x-3 gap-y-1 whitespace-nowrap" role="list">
                {sections.map((sectionItems, i) => (<div key={`section${i}`}>
                  <SettingsSection sections={sectionItems} />
                  { i < sections.length - 1 && <Divider className="my-4" /> }
                </div>))}
              </ul>
            </nav>
          </aside>

          <main className="w-full">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  )
}
